<template>
    <v-container fluid>
        <app-page-card>
            <template #header>
                {{ title }}
            </template>
            <app-container fluid>
                <app-row>
                    <app-col cols="12">
                        <data-table-with-api ref="LocationTable"
                                             :headers="headers"
                                             :url="'get_locations/'"
                                             :search-filters="[]"
                                             :showSelect="false"
                                             :loading="loading"
                                             @open-update-row="openUpdateDialog">
                            <template slot="search_right" >
                                <div align="right">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="getLocations" color="primary" icon v-bind="attrs" v-on="on" :loading="loading">
                                                <v-icon>mdi-refresh</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Actualizar</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="openCreateDialog()" color="primary" icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Nueva Ubicación</span>
                                    </v-tooltip>
                                </div>
                            </template>
                        </data-table-with-api>
                    </app-col>
                </app-row>
                
            </app-container>
        </app-page-card>

        <app-modal-prompt
            v-model="create_update_dialog"
            :confirmBtnText="modal.confirmBtnText"
            @confirm="confirm()"
            @cancel="closeDialog()"
        >
            <template #title>
              {{ modal.title }}
            </template>
            <app-modal-container>
                <v-form ref="locationDialogForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-autocomplete
                                label="Programa contable"
                                v-model="cdb_type"
                                :items="cdb_types"
                                item-text="name"
                                item-value="value"
                            ></app-autocomplete>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                label="Nombre"
                                v-model="name"
                            ></app-text-field>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                label="Ruta"
                                v-model="path"
                            ></app-text-field>
                        </app-modal-col>
                    </app-modal-row>
                </v-form>
            </app-modal-container>
        </app-modal-prompt>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import AppPageCard from '@/components/layout/AppPageCard.vue';
import DataTableWithApi from '../components/DataTableWithApi.vue';
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppContainer from '@/components/layout/AppContainer.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppAutocomplete from "@/components/layout/AppAutocomplete.vue";

export default {
    components: {
        AppPageCard,
        DataTableWithApi,
        AppModalPrompt,
        AppModalContainer,
        AppModalRow,
        AppModalCol,
        AppTextField,
        AppAutocomplete,
        AppContainer,
        AppRow,
        AppCol,
    },
    data() {
        return {
            loading: false,
            create_update_dialog: false,
            is_update: false,
            title: "Ubicaciones",
            modal: {
                title: '',
                confirmBtnText: ''
            }
        }
    },
    computed: {
        ...mapFields('locations', [
            'headers', 'locations', 'location_id', 'name', 'path', 'cdb_type', 'cdb_types',
        ]),
    },
    methods: {
        ...mapActions({
            getCdbTypes: 'locations/getCdbTypes',
            getLocations: 'locations/getLocations',
            createLocation: 'locations/createLocation',
            updateLocation: 'locations/updateLocation',
            deleteLocation: 'locations/deleteLocation',
        }),
        refresh() {
            this.loading = true;
            this.getLocations().then(() => {
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        openCreateDialog() {
            this.modal.title = 'Nueva Ubicación';
            this.modal.confirmBtnText = "Crear"
            this.is_update = false;
            this.create_update_dialog = true;
        },
        openUpdateDialog(data) {
            this.modal.title = 'Ubicación';
            this.modal.confirmBtnText = "Actualizar"
            this.is_update = true;
            this.location_id = data.id;
            this.cdb_type = data.cdb_type_value;
            this.name = data.name;
            this.path = data.path;
            this.create_update_dialog = true;
        },
        closeDialog() {
            this.create_update_dialog = false;
            this.is_update = false;
            this.location_id = '';
            this.cdb_type = '';
            this.name = '';
            this.path = '';
        },
        getLocationsTable() {
            if (this.$refs.LocationTable) {
                this.$refs.LocationTable.getItems().then(() => {
                    this.loading = false;
                }).catch(err => {
                    console.error(err)
                });
            }
        },
        create() {
            this.createLocation().then(() => {
                this.closeDialog();
                this.getLocations();
                this.getLocationsTable();
            });
        },
        update() {
            this.letter = this.letter + ':';
            this.updateLocation().then(() => {
                this.closeDialog();
                this.getLocations();
                this.getLocationsTable();
            });
        },
        confirm() {
            if (this.is_update) {
                this.update()
            } else {
                this.create()
            }
        }
    },
    mounted() {
        this.getCdbTypes();
        this.refresh();
    }
}

</script>

<style scoped>
    .primary-bckground {
        background-color: var(--v-primary-base);
    }
    .primary-border {
        border-color: var(--v-primary-base) !important;
    }
</style>